import NewsMediaCategories from "./components/NewsMediaCategories";
import NewsDataForm from "./forms/NewsDataForm";

function NewsDigitalMediaDataPage() {
    document.title = "Data - Social Media";

    return (
        <div className="content-section">
            <div className="container">
                <NewsMediaCategories />

                <h4 className="category-title">
                    Social Media (News Data)
                </h4>

                <NewsDataForm type="news_digital" />
            </div>
        </div>
    );
}

export default NewsDigitalMediaDataPage;
